<template>
  <div>
    <p
      v-if="fieldname"
      class="filter-tit"
    >
      {{ fieldname }}
    </p>
    <cube-checkbox-group
      v-model="newValue"
      shape="square"
      :options="options"
      @input="changeHandle"
    />
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: [Object, Array, String, Boolean],
      default () {
        return {}
      }
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      newValue: this.value
    }
  },
  computed: {
    fieldname () {
      return this.data.fieldname
    },
    list () {
      return this.data.options || []
    },
    options () {
      return this.list.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })
    }
  },
  methods: {
    changeHandle (val) {
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .cube-checkbox-group {
  &:after,
  &:before {
    width: 0;
  }
  .cube-checkbox {
    .border-bottom-1px:after {
      width: 0;
    }
  }

  .cube-checkbox-ui {
    font-size: 16px;
    color: #d6d6d6;
  }

  .cube-checkbox-ui.cubeic-square-border {
    border-radius: 4px;
  }
}
</style>
